import { ReactNode } from "react";
import { useSamplesSurfaceMicrobialBaseDataListQuery } from "@/services/backend/samples/api/surface-microbial-base-data-api";
import { surfaceMicrobialBaseDataKey } from "@/services/backend/samples/types/sample-base-data";
import {
  SampleBaseDataListRequest,
  SampleBaseDataTable,
  useSampleBaseDataListRequestWithCompanies,
} from "@/services/backend/samples/components/sample-base-data-table";
import { DeleteSurfaceMicrobialBaseDataDialog } from "@/services/backend/samples/components/delete-surface-microbial-base-data-dialog";

export function SurfaceMicrobialBaseDataTable({
  request,
  onRequestChange,
  renderRowLink,
  hidePagination,
  hideBorder,
}: {
  request: SampleBaseDataListRequest;
  onRequestChange: (request: SampleBaseDataListRequest) => void;
  renderRowLink: (baseDataId: string, children: ReactNode) => ReactNode;
  hidePagination?: boolean;
  hideBorder?: boolean;
}) {
  const { request: effectiveRequest, skip } =
    useSampleBaseDataListRequestWithCompanies(request);
  const { data, isLoading, error } =
    useSamplesSurfaceMicrobialBaseDataListQuery(effectiveRequest, { skip });

  return (
    <SampleBaseDataTable
      data={data}
      isLoading={isLoading}
      error={error}
      dataKey={surfaceMicrobialBaseDataKey}
      request={request}
      onRequestChange={onRequestChange}
      renderRowLink={renderRowLink}
      renderDeleteAction={(baseData) => (
        <DeleteSurfaceMicrobialBaseDataDialog baseData={baseData} />
      )}
      hidePagination={hidePagination}
      hideBorder={hideBorder}
    />
  );
}
